/**
 * Accedo OVP
 * API version: 1.2.0
 *
 * NOTE: This class was automatically generated by Swagger Code Generator. Do not edit it manually.
 */
'use strict';

var fetch = require('@accedo/vdkweb-fetch');

/**
  * @module ApiClient
  * @version 1.4.0
  */

/**
 * Manages low level client-server communications, parameter marshalling, etc. There should not be any need for an
 * application to use this class directly - the *Api and model classes provide the public API for the service. The
 * contents of this file should be regarded as internal but are documented for completeness.
 * @alias module:ApiClient
 * @class
 */
var exports = function() {

    /**
    * The authentication methods to be included for all API calls.
    * @type {Array.<String>}
    */
    this.authentications = {
    };

    /**
    * The default HTTP headers to be included for all API calls.
    * @type {Array.<String>}
    * @default {}
    */
    this.defaultHeaders = {};

    /**
    * The default HTTP timeout for all API calls.
    * @type {Number}
    * @default 60000
    */
    // TODO: implement outer timeout handling - https://github.com/github/fetch/issues/175
    this.timeout = 60000;
};

/**
* Gets the base URL of the API. It can be overridden if another URL needs to be used (other than the one specified in the definition)
* @returns {String} The API base URL.
*/
exports.prototype.getBaseUrl = function() {
  return 'https://vdk-ovp.ocs.demo.accedo.tv';
};

/**
* Returns a string representation for an actual parameter.
* @param param The actual parameter.
* @returns {String} The string representation of <code>param</code>.
*/
exports.prototype.paramToString = function(param) {
  if (param == undefined || param == null) {
    return '';
  }
  if (param instanceof Date) {
    return param.toJSON();
  }
  return param.toString();
};

/**
* Builds full URL by appending the given path to the base URL and replacing path parameter place-holders with parameter values.
* NOTE: query parameters are not handled here.
* @param {String} path The path to append to the base URL.
* @param {Object} pathParams The parameter values to append.
* @param {Object} queryParams The query parameters to append to the search part of the URL.
* @returns {String} The encoded path with parameter values substituted.
*/
exports.prototype.buildUrl = function(path, pathParams, queryParams) {
  if (!path.match(/^\//)) {
    path = '/' + path;
  }
  var url = this.getBaseUrl().replace(/\/+$/, '') + path;
  var _this = this;
  url = url.replace(/\{([\w-]+)\}/g, function(fullMatch, key) {
    var value;
    if (pathParams.hasOwnProperty(key)) {
      value = _this.paramToString(pathParams[key]);
    } else {
      value = fullMatch;
    }
    return encodeURIComponent(value);
  });

  if (Object.keys(queryParams).length) {
    url += '?';
    for (var p in queryParams) {
      if (queryParams.hasOwnProperty(p)) {
        url += encodeURIComponent(p) + '=' + encodeURIComponent(queryParams[p]) + '&';
      }
    }
  }

  return url;
};

/**
* Checks whether the given content type represents JSON.<br>
* JSON content type examples:<br>
* <ul>
* <li>application/json</li>
* <li>application/json; charset=UTF8</li>
* <li>APPLICATION/JSON</li>
* </ul>
* @param {String} contentType The MIME content type to check.
* @returns {Boolean} <code>true</code> if <code>contentType</code> represents JSON, otherwise <code>false</code>.
*/
exports.prototype.isJsonMime = function(contentType) {
  return Boolean(contentType != null && contentType.match(/^application\/json(;.*)?$/i));
};

/**
* Chooses a content type from the given array, with JSON preferred; i.e. return JSON if included, otherwise return the first.
* @param {Array.<String>} contentTypes
* @returns {String} The chosen content type, preferring JSON.
*/
exports.prototype.jsonPreferredMime = function(contentTypes) {
  for (var i = 0; i < contentTypes.length; i++) {
    if (this.isJsonMime(contentTypes[i])) {
      return contentTypes[i];
    }
  }
  return contentTypes[0];
};

/**
* Checks whether the given parameter value represents file-like content.
* @param param The parameter to check.
* @returns {Boolean} <code>true</code> if <code>param</code> represents a file.
*/
exports.prototype.isFileParam = function(param) {
  // fs.ReadStream in Node.js (but not in runtime like browserify)
  if (typeof window === 'undefined' && typeof require === 'function' && require('fs') && param instanceof require('fs').ReadStream) {
    return true;
  }
  // Buffer in Node.js
  if (typeof Buffer === 'function' && param instanceof Buffer) {
    return true;
  }
  // Blob in browser
  if (typeof Blob === 'function' && param instanceof Blob) {
    return true;
  }
  // File in browser (it seems File object is also instance of Blob, but keep this for safe)
  if (typeof File === 'function' && param instanceof File) {
    return true;
  }
  return false;
};

/**
* Normalizes parameter values:
* <ul>
* <li>remove nils</li>
* <li>keep files and arrays</li>
* <li>format to string with `paramToString` for other cases</li>
* </ul>
* @param {Object.<String, Object>} params The parameters as object properties.
* @returns {Object.<String, Object>} normalized parameters.
*/
exports.prototype.normalizeParams = function(params) {
  var newParams = {};
  for (var key in params) {
    if (params.hasOwnProperty(key) && params[key] != undefined && params[key] != null) {
      var value = params[key];
      if (this.isFileParam(value) || Array.isArray(value)) {
        newParams[key] = value;
      } else {
        newParams[key] = this.paramToString(value);
      }
    }
  }
  return newParams;
};

/**
* Enumeration of collection format separator strategies.
* @enum {String}
* @readonly
*/
exports.CollectionFormatEnum = {
  /**
   * Comma-separated values. Value: <code>csv</code>
   * @const
   */
  CSV: ',',
  /**
   * Space-separated values. Value: <code>ssv</code>
   * @const
   */
  SSV: ' ',
  /**
   * Tab-separated values. Value: <code>tsv</code>
   * @const
   */
  TSV: '\t',
  /**
   * Pipe(|)-separated values. Value: <code>pipes</code>
   * @const
   */
  PIPES: '|',
  /**
   * Native array. Value: <code>multi</code>
   * @const
   */
  MULTI: 'multi'
};

/**
* Builds a string representation of an array-type actual parameter, according to the given collection format.
* @param {Array} param An array parameter.
* @param {module:ApiClient.CollectionFormatEnum} collectionFormat The array element separator strategy.
* @returns {String|Array} A string representation of the supplied collection, using the specified delimiter. Returns
* <code>param</code> as is if <code>collectionFormat</code> is <code>multi</code>.
*/
exports.prototype.buildCollectionParam = function buildCollectionParam(param, collectionFormat) {
  if (param == null) {
    return null;
  }
  switch (collectionFormat) {
    case 'csv':
      return param.map(this.paramToString).join(',');
    case 'ssv':
      return param.map(this.paramToString).join(' ');
    case 'tsv':
      return param.map(this.paramToString).join('\t');
    case 'pipes':
      return param.map(this.paramToString).join('|');
    case 'multi':
      return param.map(this.paramToString);
    default:
      throw new Error('Unknown collection format: ' + collectionFormat);
  }
};

/**
* Applies authentication headers to the request.
* @param {Object} request The request object.
* @param {Array.<String>} authNames An array of authentication method names.
*/
exports.prototype.applyAuthToRequest = function(request, authNames) {
  // TODO: fetchify
  var _this = this;
  authNames.forEach(function(authName) {
    var auth = _this.authentications[authName];
    switch (auth.type) {
      case 'basic':
        if (auth.username || auth.password) {
          request.auth(auth.username || '', auth.password || '');
        }
        break;
      case 'apiKey':
        if (auth.apiKey) {
          var data = {};
          if (auth.apiKeyPrefix) {
            data[auth.name] = auth.apiKeyPrefix + ' ' + auth.apiKey;
          } else {
            data[auth.name] = auth.apiKey;
          }
          if (auth['in'] === 'header') {
            request.set(data);
          } else {
            request.query(data);
          }
        }
        break;
      case 'oauth2':
        if (auth.accessToken) {
          request.set({'Authorization': 'Bearer ' + auth.accessToken});
        }
        break;
      default:
        throw new Error('Unknown authentication type: ' + auth.type);
    }
  });
};

/**
* Deserializes an HTTP response body into a value of the specified type.
* @param {Object} response A SuperAgent response object.
* @param {(String|Array.<String>|Object.<String, Object>|Function)} returnType The type to return. Pass a string for simple types
* or the constructor function for a complex type. Pass an array containing the type name to return an array of that type. To
* return an object, pass an object with one property whose name is the key type and whose value is the corresponding value type:
* all properties on <code>data<code> will be converted to this type.
* @returns A value of the specified type.
*/
exports.prototype.deserialize = function deserialize(response, returnType) {
  if (response == null || returnType == null) {
    return null;
  }
  // Parsing response body (https://developer.mozilla.org/en-US/docs/Web/API/Body/json)
  return response.json()
    .then(function (body) {
      return exports.convertToType(body, returnType);
    });
};

/**
* Invokes the REST service using the supplied settings and parameters.
* @param {String} path The base URL to invoke.
* @param {String} httpMethod The HTTP method to use.
* @param {Object.<String, String>} pathParams A map of path parameters and their values.
* @param {Object.<String, Object>} queryParams A map of query parameters and their values.
* @param {Object.<String, Object>} headerParams A map of header parameters and their values.
* @param {Object.<String, Object>} formParams A map of form parameters and their values.
* @param {Object} bodyParam The value to pass as the request body.
* @param {Array.<String>} authNames An array of authentication type names.
* @param {Array.<String>} contentTypes An array of request MIME types.
* @param {Array.<String>} accepts An array of acceptable response MIME types.
* @param {(String|Array|Object|Function)} returnType The required type to return; can be a string for simple types or the
* constructor for a complex type.
* @returns {Promise} A {@link https://www.promisejs.org/|Promise} object.
*/
exports.prototype.call = function call(path, httpMethod, pathParams,
  queryParams, headerParams, formParams, bodyParam, authNames, contentTypes, accepts, returnType) {

  var _this = this;
  var url = this.buildUrl(path, pathParams, this.normalizeParams(queryParams));

  var headers = Object.assign({}, this.defaultHeaders, this.normalizeParams(headerParams));
  var contentType = this.jsonPreferredMime(contentTypes);
  headers['Content-Type'] = contentType;
  var acceptType = this.jsonPreferredMime(accepts);
  if (acceptType) {
    headers['Accept'] = acceptType;
  }

  if (contentType === 'multipart/form-data') {
    throw new Error('Not implemented - contentType not supported');
  }

  var body;
  if (httpMethod !== 'GET' && httpMethod !== 'HEAD' && bodyParam) {
    body = JSON.stringify(bodyParam);
  }

  var options = {
    method: httpMethod,
    headers: headers
  };

  if (body) {
    options.body = body;
  }

  // TODO - this.applyAuthToRequest(request, authNames);

    return new Promise(function(resolve, reject) {
      fetch(url, options)
        .then(function (response) {
          // Fetch API only rejects a promise when a network error is encountered
          // so an error response needs to be thrown forward
          // https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#Checking_that_the_fetch_was_successful
          if (!response.ok) {
            throw new Error(response.statusText);
          }
          resolve(_this.deserialize(response, returnType));
        })
        .catch(function (error) {
          reject(error);
        });
      });
    };

/**
* Parses an ISO-8601 string representation of a date value.
* @param {String} str The date value as a string.
* @returns {Date} The parsed date object.
*/
exports.parseDate = function(str) {
  return new Date(str.replace(/T/i, ' '));
};

/**
* Converts a value to the specified type.
* @param {(String|Object)} data The data to convert, as a string or object.
* @param {(String|Array.<String>|Object.<String, Object>|Function)} type The type to return. Pass a string for simple types
* or the constructor function for a complex type. Pass an array containing the type name to return an array of that type. To
* return an object, pass an object with one property whose name is the key type and whose value is the corresponding value type:
* all properties on <code>data<code> will be converted to this type.
* @returns An instance of the specified type.
*/
exports.convertToType = function(data, type) {
  switch (type) {
    case 'Boolean':
      return Boolean(data);
    case 'Integer':
      return parseInt(data, 10);
    case 'Number':
      return parseFloat(data);
    case 'String':
      return String(data);
    case 'Date':
      return this.parseDate(String(data));
    default:
      if (type === Object) {
        // generic object, return directly
        return data;
      } else if (typeof type === 'function') {
        // for model type like: User
        return type.constructFromObject(data);
      } else if (Array.isArray(type)) {
        // for array type like: ['String']
        var itemType = type[0];
        return data.map(function(item) {
          return exports.convertToType(item, itemType);
        });
      } else if (typeof type === 'object') {
        // for plain object type like: {'String': 'Integer'}
        var keyType, valueType;
        for (var k in type) {
          if (type.hasOwnProperty(k)) {
            keyType = k;
            valueType = type[k];
            break;
          }
        }
        var result = {};
        for (var k in data) {
          if (data.hasOwnProperty(k)) {
            var key = exports.convertToType(k, keyType);
            var value = exports.convertToType(data[k], valueType);
            result[key] = value;
          }
        }
        return result;
      } else {
        // for unknown type, return the data directly
        return data;
      }
  }
};

/**
* Constructs a new map or array model from REST data.
* @param {Object|Array} data The REST data.
* @param {Object|Array} obj The target object or array.
* @param {(String|Array.<String>|Object.<String, Object>|Function)} itemType The type to construct from input data.
*/
exports.constructFromObject = function(data, obj, itemType) {
  if (Array.isArray(data)) {
    for (var i = 0; i < data.length; i++) {
      if (data.hasOwnProperty(i))
        obj[i] = exports.convertToType(data[i], itemType);
    }
  } else {
    for (var k in data) {
      if (data.hasOwnProperty(k))
        obj[k] = exports.convertToType(data[k], itemType);
    }
  }
};

module.exports = exports;
